'use strict';

var _regeneratorRuntime = require("/home/hashir/WORK/secureX/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/hashir/WORK/secureX/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var protons = require('protons');

var proto = protons(require('./dag.proto.js'));

var DAGLink = require('./dag-link');

var DAGNode = require('./dag-node');

var multicodec = require('multicodec');

var multihashing = require('multihashing-async');

exports = module.exports;
exports.codec = multicodec.DAG_PB;
exports.defaultHashAlg = multicodec.SHA2_256;
/**
 * Calculate the CID of the binary blob.
 *
 * @param {Object} binaryBlob - Encoded IPLD Node
 * @param {Object} [userOptions] - Options to create the CID
 * @param {number} [userOptions.cidVersion=1] - CID version number
 * @param {string} [UserOptions.hashAlg] - Defaults to the defaultHashAlg of the format
 * @returns {Promise.<CID>}
 */

var cid = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(binaryBlob, userOptions) {
    var defaultOptions, options, multihash, codecName, cid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            defaultOptions = {
              cidVersion: 1,
              hashAlg: exports.defaultHashAlg
            };
            options = Object.assign(defaultOptions, userOptions);
            _context.next = 4;
            return multihashing(binaryBlob, options.hashAlg);

          case 4:
            multihash = _context.sent;
            codecName = multicodec.print[exports.codec];
            cid = new CID(options.cidVersion, codecName, multihash);
            return _context.abrupt("return", cid);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function cid(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Serialize internal representation into a binary PB block.
 *
 * @param {Object} node - Internal representation of a CBOR block
 * @returns {Buffer} - The encoded binary representation
 */


var serialize = function serialize(node) {
  var data = node.Data;
  var links = node.Links || []; // If the node is not an instance of a DAGNode, the link.hash might be a Base58 encoded string; decode it

  if (!DAGNode.isDAGNode(node) && links) {
    links = links.map(function (link) {
      return DAGLink.isDAGLink(link) ? link : DAGLink.util.createDagLinkFromB58EncodedHash(link);
    });
  }

  var serialized = proto.PBNode.encode(toProtoBuf({
    Data: data,
    Links: links
  }));
  return serialized;
};
/**
 * Deserialize PB block into the internal representation.
 *
 * @param {Buffer} buffer - Binary representation of a PB block
 * @returns {Object} - An object that conforms to the IPLD Data Model
 */


var deserialize = function deserialize(buffer) {
  var pbn = proto.PBNode.decode(buffer);
  var links = pbn.Links.map(function (link) {
    return new DAGLink(link.Name, link.Tsize, link.Hash);
  });
  var data = pbn.Data == null ? Buffer.alloc(0) : pbn.Data;
  return new DAGNode(data, links, buffer.length);
};

function toProtoBuf(node) {
  var pbn = {};

  if (node.Data && node.Data.length > 0) {
    pbn.Data = node.Data;
  } else {
    // NOTE: this has to be null in order to match go-ipfs serialization `null !== new Buffer(0)`
    pbn.Data = null;
  }

  if (node.Links && node.Links.length > 0) {
    pbn.Links = node.Links.map(function (link) {
      return {
        Hash: link.Hash.buffer,
        Name: link.Name,
        Tsize: link.Tsize
      };
    });
  } else {
    pbn.Links = null;
  }

  return pbn;
}

exports.serialize = serialize;
exports.deserialize = deserialize;
exports.cid = cid;